import { AppBar as MuiAppBar, useTheme } from "@mui/material";
import { AppBarProps } from "@mui/material/AppBar";
import { useHomeRoute } from "hooks/useHomeRoute";
import { useThemeMode } from "hooks/useThemeMode";

import { homeLinesBackgroundSx, homeLinesVeilColor } from "./homeLinesBackground";

/** Top nav height as spacing units (73px ÷ 8 default spacing). */
export const xsHeight = 9.125;
/** Top nav height as spacing units (77px ÷ 8 default spacing). */
export const mdHeight = 9.625;

export const AppBar = (props: AppBarProps) => {
  const theme = useTheme();
  const { themeMode } = useThemeMode();
  const isHome = useHomeRoute();
  const canvasColor = homeLinesVeilColor(theme);
  const defaultBackgroundColor =
    themeMode === "dark" ? theme.palette.nav.background : theme.palette.background.default;

  return (
    <MuiAppBar
      position="sticky"
      elevation={0}
      {...props}
      sx={{
        ...(isHome
          ? {
              backgroundColor: canvasColor,
              ...homeLinesBackgroundSx(themeMode, canvasColor, { attachment: "fixed" }),
            }
          : {
              backgroundImage: "none",
              backgroundColor: defaultBackgroundColor,
            }),
        color: theme.palette.text.primary,
        minHeight: {
          xs: theme.spacing(xsHeight),
          md: theme.spacing(mdHeight),
        },
        borderBottom: isHome ? "none" : "1px solid",
        borderColor: theme.palette.divider,
        ...props.sx,
      }}
    >
      {props.children}
    </MuiAppBar>
  );
};

/**
 * Designed to sit under the TopNavBar. They are both sticky by default.
 * @param props
 * @returns
 */
export const SubNavAppBar = (props: AppBarProps) => {
  const theme = useTheme();
  return (
    <MuiAppBar
      position="sticky"
      elevation={0}
      {...props}
      sx={{
        backgroundImage: "none",
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.nav.background
            : theme.palette.background.default,
        color: theme.palette.text.primary,
        top: {
          xs: theme.spacing(xsHeight),
          md: theme.spacing(mdHeight),
        },
        ...props.sx,
      }}
    >
      {props.children}
    </MuiAppBar>
  );
};
